import BaseInput, { IBaseInputProps } from "./BaseInput"

export default function EmailInput({ children, ...props }: IBaseInputProps) {
  return (
    <BaseInput {...props} type="email">
      {children}
    </BaseInput>
  )
}
